import { defineComponent as _defineComponent } from 'vue'

import { NuxtError } from "@nuxt/types";
import { PropType, computed, defineComponent, onMounted, useMeta } from "@nuxtjs/composition-api";

import { useAmplitude, useMetaService, useTranslate } from "@/composables";
import { NOT_FOUND } from "@/utils/enums/http-codes";

const __default__ = defineComponent({
  name: "ErrorLayout",
  head: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  error: {
    type: Object as PropType<NuxtError>,
    default: () => null,
  },
},
  setup(__props) {

const props = __props;

const amplitude = useAmplitude();
const metaService = useMetaService();
const { t } = useTranslate();



const translations = computed(() => ({
  notFoundTitle: t("404 Oh No!").value /* The title on the error page */,
  genericTitle: t("An error occurred").value /* The title on the error page */,
  notFoundMessage: t("Sorry, but this link is invalid. Please double check your URL or discover new posts below.")
    .value /* Subtext on the error page */,
  genericMessage: t("Sorry, but we encountered an error. Please try again later or discover new posts below.")
    .value /* Subtext on the error page */,
  btnText: t("Discover More").value /* Button text on error page */,
}));

const errorTitle =
  props.error?.statusCode === NOT_FOUND ? translations.value.notFoundTitle : translations.value.genericTitle;

onMounted(() => {
  const pageName = props.error?.statusCode === NOT_FOUND ? "/page/404" : "/page/error";
  amplitude?.sendEvent(pageName, {
    message: props.error?.message,
    path: props.error?.path,
    statusCode: props.error?.statusCode,
  });
});

useMeta(() => {
  const head = metaService.setPageMeta({
    title: errorTitle,
    customTitle: true,
    description: "",
    noIndex: true,
  });
  return head;
});

return { __sfc: true,amplitude, metaService, t, props, translations, errorTitle }
}

})